import { DeleteRequest, GetExcelRequest, GetRequest, PatchRequest, PostRequest, PutRequest } from '../service';

const ControllerName = "user"

export const ExportUsersExcel = (link) =>
    GetExcelRequest(link, ControllerName)


export const GetAllUsers = (link) =>
    GetRequest(ControllerName + link)


export const GetUserDetails = (userID) =>
    GetRequest(ControllerName + '/' + userID)


export const AddUser = (UserData) =>
    PostRequest(ControllerName, UserData)


export const UpdateUser = (Userid, UserData) =>
    PutRequest(ControllerName + "/" + Userid, UserData)


export const DeleteUser = (Userid) =>
    DeleteRequest(ControllerName + "/" + Userid)


export const Register = (UserData) =>
    PostRequest(ControllerName + "/register", UserData)


export const ChangePassword = (PasswordData) =>
    PatchRequest(ControllerName + "/changePassword", PasswordData)


export const ForgetPassword = (Email) =>
    PatchRequest("Auth/ForgetPassword", Email)

export const ResendCode = (Email) =>
    PatchRequest("Auth/ResendResetOtp", Email)

export const VerifyResetCode = (CodeData) =>
    PostRequest("Auth/verifyResetOtp", CodeData)


export const ResetPassword = (ResetPasswordData) =>
    PostRequest("Auth/ResetPassword", ResetPasswordData)


export const VerifyAccount = (code) =>
    PatchRequest(ControllerName + "/verifyAccount?code=" + code)


export const GetUserInfo = () =>
    GetRequest(`${ControllerName}/user-info`)

export const Login = (userInfo) =>
    PostRequest("auth/token", userInfo)


export const Logout = () =>
    PostRequest("auth/logout", {})




